import React from "react";

interface SearchCalendarIconProps {
  className?: string;
  size?: number;
  color?: string;strokeWidth?: number; strokeWidth2?: number;
}

const SearchCalendarIcon: React.FC<SearchCalendarIconProps> = ({
  size = 16,
  color = '#1E1E1E',
}) => (
<svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.33337 1.33398V3.33398" stroke={color} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M10.6666 1.33398V3.33398" stroke={color} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M12.1333 14.2667C13.3115 14.2667 14.2667 13.3115 14.2667 12.1333C14.2667 10.9551 13.3115 10 12.1333 10C10.9551 10 10 10.9551 10 12.1333C10 13.3115 10.9551 14.2667 12.1333 14.2667Z" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
<path d="M14.6667 14.6667L14 14" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
<path d="M2.33337 6.06055H13.6667" stroke={color} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M8.91333 14.6673H5.33333C3 14.6673 2 13.334 2 11.334V5.66732C2 3.66732 3 2.33398 5.33333 2.33398H10.6667C13 2.33398 14 3.66732 14 5.66732V8.66732" stroke={color} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M7.9963 9.13411H8.00229" stroke={color} stroke-width="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M5.53023 9.13411H5.53622" stroke={color} stroke-width="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M5.53023 11.1341H5.53622" stroke={color} stroke-width="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
</svg>


);

export default SearchCalendarIcon;
